import * as React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import CandidateApp from './CandidateApp';
import { InterviewProvider } from './Context/mainContext';

ReactDOM.render(
  <div>
    <InterviewProvider>
      <CandidateApp />
    </InterviewProvider>
  </div>,
  document.querySelector('#root')
);